// Branches only. Shared table methods are in tableMixin.js.
export default {
    name: "Branches",
    methods: {
        openDatePicker() {
            this.$refs.dateInput.showPicker?.(); // supported in Chromium-based browsers
        },
        clearForm() {
            this.isEditing = false;
            this.isSaving = false;
            this.submitted = false;

            this.formInputs.id = "";
            this.formInputs.owner_company_id = "";
            this.formInputs.branch_name = "";
            this.formInputs.branch_code = "";
            this.formInputs.email = "";
            this.formInputs.phone = "";
            this.formInputs.address = "";
            this.formInputs.city = "";
            this.formInputs.country = "";
            this.formInputs.postal_code = "";
            this.formInputs.is_active = true;

            this.$clearValidationStates("#recordForm");
        },
    },
};